import { render, staticRenderFns } from "./FormSubmissionList.vue?vue&type=template&id=609e4d68&scoped=true&"
import script from "./FormSubmissionList.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e4d68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VSelect,VTextField})
